import Splide from '@splidejs/splide';

const photoSplide = new Splide('.splide-photo-carousel', {
  type: 'loop',
  perPage: 3,
  gap: '36px',
  arrows: false,
  focus: 'center',
  perMove: 1,
  trimSpace: false,
  breakpoints: {
    1100: {
      perPage: 1.5,
      padding: '10%'
    },
    600: {
      perPage: 1,
      padding: 0,
    }
  }
});

photoSplide.mount();

const testimonySplide = new Splide('.splide-testimonials', {
  type: 'loop',
  perPage: 1,
  gap: '24px',
  arrows: false,
  focus: 'center',
});

testimonySplide.mount();
